import React from 'react';
import { useSelector } from 'react-redux';
import { selectUserIsIdentified } from 'core/selectors/user';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectSiteUrl } from 'core/selectors/app';
import { useCheckIsCardHolder } from 'org/hooks/useCheckIsCardHolder';

function StaticBanner() {
  const siteUrl = useSelector(selectSiteUrl);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const isCardHolder = useCheckIsCardHolder();

  const getTitle = () => {
    if (!userIsIdentified) {
      return <>Plus, new members earn up to 1,000 bonus miles when you spend $25</>;
    }

    return (
      <>
        United MileagePlus<sup>&reg;</sup> Members earn {isCardHolder ? '1,000' : '500'} bonus miles when you spend $25
      </>
    );
  };

  const title = getTitle();

  return (
    <div className="mn_acquisitionBonusBanner mn_staticBanner">
      <h3>{title}</h3>
      <a href={`${siteUrl}/signin`}>Learn more</a>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><StaticBanner {...props} /></ComponentErrorBoundary>;
